import httpService from './httpService'

const serverPath = window.location.origin
const arsmoApi = '/arsmo_api'

const userService = {
  getExperts: (params) => {
    const url = `${serverPath}${arsmoApi}/experts`
    return httpService.httpGet(url, params)
  },
}

export default userService



// WEBPACK FOOTER //
// ./src/services/user-service.js